import { render, staticRenderFns } from "./ScientificDegreeChangeActivationType.vue?vue&type=template&id=275c97e1&"
import script from "./ScientificDegreeChangeActivationType.vue?vue&type=script&lang=js&"
export * from "./ScientificDegreeChangeActivationType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports